import { GetRulesValuesList } from './types/getRulesValuesList.types'

export const getRulesValuesList: GetRulesValuesList = (
  data,
  index = 0,
  arr = []
) => {
  if (!arr[index]) {
    arr[index] = []
  }
  if (Array.isArray(data)) {
    (arr[index] as number[]).push(...data)
  } else {
    const keys = Object.keys(data)
    keys.forEach(key => {
      (arr[index] as number[]).push(+key)
      getRulesValuesList(data[+key], index + 1, arr)
    })
  }
  return arr
}
